


















































































































import ErrorAlert from '@/components/common/ErrorAlert.vue';
import {
  IFormSectionFieldData,
  ConstraintActionEnum,
  IFormSectionFieldConstraint,
  IFormFieldData,
  IFormTemplate,
  FormSectionFieldConstraintCondition
} from '@/models';

import { mapGetters } from 'vuex';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'FormBuilderConstraintConditionsDrawer',

  components: {
    ErrorAlert
  },

  props: {
    sectionFields: Array as PropType<IFormSectionFieldData[]>,
    selectedConstraint: Object as PropType<IFormSectionFieldConstraint>,
    selectedFieldIndex: Number,
    templateId: Number,
    drawer: Boolean
  },

  data() {
    return {
      ConstraintActionEnum,
      loading: false,
      errorMessage: '',
      detailErrorMessage: ''
    };
  },

  computed: {
    ...mapGetters({
      getFormTemplateById: 'formTemplate/getFormTemplateById'
    }),

    navDrawer: {
      get(): boolean {
        return this.drawer;
      },
      set(value: boolean) {
        this.$emit('update:drawer', value);
      }
    }
  },

  methods: {
    clearAllErrors() {
      this.detailErrorMessage = '';
      this.errorMessage = '';
    },

    getFieldOptionQuestionsBeforeSelectedField() {
      const questionFields = [] as IFormSectionFieldData[];

      const template: IFormTemplate = this.getFormTemplateById(this.templateId);

      let sectionField = {} as IFormSectionFieldData;
      let index = 0;

      while (
        index < template.sections!.length &&
        sectionField?.id != this.sectionFields[this.selectedFieldIndex].id
      ) {
        const sectionFields = template.sections![index].section_fields;

        for (let i = 0; i < sectionFields.length; i++) {
          sectionField = sectionFields[i];
          if (
            sectionField?.id == this.sectionFields[this.selectedFieldIndex].id
          ) {
            break;
          }

          if (
            (sectionField.field_template as IFormFieldData).options!.length > 0
          ) {
            questionFields.push(sectionField);
          }
        }
        index++;
      }

      return questionFields;
    },

    genSelectedFormQuestionOptions(field: number) {
      const formField = this.getFieldOptionQuestionsBeforeSelectedField().find(
        question => question.id == field
      );
      return (formField?.field_template as IFormFieldData).options ?? [];
    },

    removeConstraintCondition(index: number) {
      this.selectedConstraint.conditions.splice(index, 1);
    },

    addConstraintCondition() {
      //a default 0 is added here as a place holder for the inpput
      const condition = new FormSectionFieldConstraintCondition({
        field_option: 0,
        form_section_field: 0
      });
      this.selectedConstraint.conditions.push(condition);
    }
  }
});
